import { ColumnDef } from "@tanstack/react-table";
import { TransactionStatus } from "@/core/components/transaction-status";
import {
  PAYOUT_STATUS,
  PAYOUT_STATUS_TO_LABEL,
  PAYOUT_STATUS_TO_PROGRESS,
} from "@/payouts/constants";
import { IPayout, PayoutStatus } from "@/payouts/payouts";

const Content = ({ status }: { status?: PayoutStatus }) => {
  if (!status) {
    return "No status";
  }

  const label = PAYOUT_STATUS_TO_LABEL[status];
  const progress = PAYOUT_STATUS_TO_PROGRESS[status];
  const isError = status === PAYOUT_STATUS.CANCELED;

  return (
    <TransactionStatus label={label} progress={progress} isError={isError} />
  );
};

export const StatusCol = (): ColumnDef<IPayout> => ({
  header: "Status",
  accessorKey: "status",
  cell: ({ row }) => <Content status={row.original.status} />,
});
